import { getSiteDefaults } from './getSiteDefaults';

/** Frozen bundled defaults (captured once at startup, before any API hydrate). */
export const STATIC_SITE_DEFAULTS = getSiteDefaults();
